import { useSoundPath } from 'hooks/useSoundPath';
import React from 'react'

const MainSortOrder = ({ isPopup, setIsPopup, current, setCurrentSort, list }) => {

  const playSound = useSoundPath();

  const showPopup = () => {
    setIsPopup((prevValue) => {
      const newIsFilters = !prevValue;

      if (newIsFilters) {
          playSound('openSubmenu');
      } else {
          playSound('closeSubmenu');
      }

      return newIsFilters;
    })
  }

  return (
    <div className='gradient-block__search-popup-wrapper'>
      <button className={`gradient-block__search-sort ${isPopup === true ? 'active' : ''}`} onClick={showPopup}>
        Sort: <b className="gradient-block__search-sort-current">{current}</b>
      </button>
      <section className="gradient-block__search-popup">
        <b className="gradient-block__search-popup-title">Sort</b>
        <div className="gradient-block__search-popup-actions">
          {
            list.map((sort) => (
              <button
                key={sort.label}
                onClick={() => {
                  setIsPopup(false);
                  setCurrentSort(sort)
                }}
                className={`gradient-block__search-popup-action ${current === sort.label ? 'active' : ''}`}>
                {sort.label}
              </button>
            ))
          }
        </div>
      </section>
    </div>
  )
}

export default MainSortOrder;
